module.exports = __webpack_public_path__ + "dbd30e4d7feec339528cb5eb3d749e72.png";